import { Select, Tabs, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { getCurrentRole } from "../../../../../helpers/authFunctions";
import { CM, FL, ML, PA, PFA } from "../../../../router/AddRoutesJson";
import ServerProgress from "./ServerProgress";
import TrainLogs from "./TrainLogs";
import ModelResult from "./ModelResult";
import VersionLockUnlock from "../../../client-manager/VersionLockUnlock";
import axios from "axios";
import { useParams } from "react-router-dom";
import useProjectInfoQuery from "../../../../../components/hooks/useProjectInfoQuery";
import {
  fetchVersions,
  getProjectInfoById,
} from "../../../../../api/apiCallManager";
import { useSelectedServerVersionStore } from "./../../../../../components/hooks/useSelectedServerVersionStore";
import { useQuery } from "@tanstack/react-query";

function ModelTab() {
  const [selectedValue, setSelectedValue] = useState("");
  const {
    selectedServerVersionZustandState,
    setSelectedServerVersionZustandState,
  } = useSelectedServerVersionStore();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const {
    data: projectInfoData,
    error: projectInfoErro,
    isLoading: projectInfoLoading,
  } = useProjectInfoQuery(id, getProjectInfoById);
  const items = [
    {
      key: "EDA",
      label: "EDA",
      children: <ServerProgress />,
      role: [CM, ML, FL, PA, PFA],
    },
    {
      key: "TRAIN_LOGS",
      label: "Train Model",
      children: <TrainLogs />,
      role: [CM, ML, FL, PA, PFA],
    },
    // {
    //   key: "TRAIN_MODEL_RESULT",
    //   label: "Model Result",
    //   children: <ModelResult />,
    //   role: [CM, ML, FL, PA, PFA],
    // },
  ];

  const currentRole = getCurrentRole();
  const filteredItems = items.filter((item) =>
    item?.role?.includes(currentRole)
  );

  // Handle dropdown value change
  const handleChange = (value) => {
    setSelectedServerVersionZustandState(value);
    setSelectedValue(value);
  };

  // Handle clearing dropdown
  const handleClear = () => {
    setDropdownOpen(false);
  };
  // projectInfoData

  const { data: serverVersions, isLoading: isFetchServerVersionLoading } =
    useQuery({
      queryKey: ["serverVersions_"],
      queryFn: () => fetchVersions(projectInfoData),
    });
  return (
    <div className="px-5 pt-2">
      <div className="flex mb-3 items-center">
        <p className="mx-2">Server Version:</p>
        {/* {JSON.stringify(serverVersions)}-------- */}
        <Select
          open={dropdownOpen}
          loading={isFetchServerVersionLoading}
          className="w-[196px] lowercase"
          value={selectedServerVersionZustandState}
          placeholder={loading ? "Loading..." : "Select Version"}
          onChange={handleChange}
          onDropdownVisibleChange={(visible) => setDropdownOpen(visible)}
          dropdownRender={(menu) => (
            <>
              {menu}
              <div className="my-3"></div>
              <div className="flex justify-center" onClick={handleClear}>
                <VersionLockUnlock />
              </div>
            </>
          )}
        >
          {serverVersions?.map((version, index) => (
            <Select.Option key={index} value={version}>
              {version}
            </Select.Option>
          ))}
        </Select>
      </div>
      <Tabs destroyInactiveTabPane={true} centered items={filteredItems} />
      <div className="py-3"> </div>
    </div>
  );
}

export default ModelTab;
